// @flow

import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import GenerateReportButton from '../Buttons/GenerateReportButton'
import './AdministratorTable.css'
import Paginate from '../Buttons/Paginate'
import { time, dateTime } from '../timeutils'
import Loading from '../Icons/loading.gif'

type Props = {
  changeOffset: Function,
  toggleSort: Function,
  data: Array,
  page: number,
  totalAdmins: number,
  sort: String,
  generateReportClick: Function,
  status: String
}

/**
  * Diplay for administrator table
  * @class
  * @extends Component
*/
class AdministratorTable extends Component<Props> {
  /** render function */
  render () {
    const headers = (<tr>
      <th id={this.props.sort.split(' ')[0] === 'name' ? 'adminHeader' : ''} className={this.props.sort.split(' ')[0] === 'name' ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''} onClick={(e) => this.props.toggleSort('name')}>
        <span>Name</span></th>
      <th id={this.props.sort.split(' ')[0] === 'avgDurationInCMS' ? 'adminHeader' : ''} className={this.props.sort.split(' ')[0] === 'avgDurationInCMS' ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''} onClick={(e) => this.props.toggleSort('avgDurationInCMS')}>
        <span>Time Spent</span></th>
      <th id={this.props.sort.split(' ')[0] === 'contentAdded' ? 'adminHeader' : ''} className={this.props.sort.split(' ')[0] === 'contentAdded' ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''} onClick={(e) => this.props.toggleSort('contentAdded')}>
        <span>Content Added</span></th>
      <th id={this.props.sort.split(' ')[0] === 'contentFoldersAdded' ? 'adminHeader' : ''} className={this.props.sort.split(' ')[0] === 'contentFoldersAdded' ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''} onClick={(e) => this.props.toggleSort('contentFoldersAdded')}>
        <span>Folders Added</span></th>
      <th id={this.props.sort.split(' ')[0] === 'lastAdminLogin' ? 'adminHeader' : ''} className={this.props.sort.split(' ')[0] === 'lastAdminLogin' ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''} onClick={(e) => this.props.toggleSort('lastAdminLogin')}>
        <span>Last Login</span></th>
    </tr>)
    const users = this.props.data.map((admin, i) => {
      if (admin.name === 'Loading') {
        return (<tr key={Math.random()}><td><img src={Loading} alt='Loading' /></td></tr>)
      } else if (admin.name === '') {
        return false // removes admin from list that does not have name
      } else {
        return (
          <tr key={i}>
            <td id={admin.adminType} className='role'><Link to={{ pathname: '/admindetails', search: '?id=' + admin._id + '&date=Week&filter=__' }}>{admin.name} </Link></td>
            <td>{time(admin.avgDurationInCMS)}</td>
            <td>{admin.contentAdded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td>{admin.contentFoldersAdded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td>{dateTime(admin.lastAdminLogin) || '--'}</td>
          </tr>
        )
      }
    }
    )
    return (
      <div>
        <div className='table-wrapper'>
          <div className='AdministratorTable'>
            <h4 className='flex align-center space-between'>Administrator Users<GenerateReportButton status={this.props.status} generateReportClicked={this.props.generateReportClick} />
            </h4>
            <table>
              <thead>{headers}</thead>
              <tbody>
                {users}
              </tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalAdmins} />
      </div>
    )
  }
}

export default AdministratorTable
